import React from "react";
import "./ProcessCovered.scss";
import badgeIcon from "../../../assets/badge.svg";
import UseBranchInfo from "../../../hooks/UseBranchInfo";

const ProcessCovered = () => {
  const [branchInfo] = UseBranchInfo();

  return (
    <>
      <div className="process_covered">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 my-auto"
              data-aos="fade-down"
              data-aos-anchor-placement="center-bottom"
            >
              <h3>The Importance of Being Covered</h3>
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-left"
              data-aos-anchor-placement="center-bottom"
            >
              <p>
                {/* Starting from August, 2013 Sonali Life Insurance established
                itself by setting a milestone through transparent and value
                addition service and thus gain the trust of policy holders. The
                number of agents, policy holders and well wishers are growing in
                a daily basis. */}
                The Company is managed by a team of highly qualified and
                experienced professionals
              </p>
            </div>
          </div>
          <div
            className="process_covered_content"
            data-aos="fade-up"
            data-aos-anchor-placement="center-bottom"
          >
            <div className="row justify-content-around">
              {/* <div className="col-lg-2 col-6 mobile_circle">
                <div className="circle_box_content">
                  <div className="my-auto">
                    <h6>Total Claim Processed</h6>
                    <h5>2493</h5>
                  </div>
                </div>
              </div> */}
              <div className="col-lg-3 col-6 mobile_circle">
                <div className="circle_box_content">
                  <div className="my-auto">
                    <h6>
                      Total Claim <br /> Processed
                    </h6>
                    <h5>2493</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-6 mobile_circle">
                <div className="circle_box_content">
                  <div className="my-auto">
                    <h6>Total Employee</h6>
                    <h5>500+</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-6 mobile_circle">
                <div className="circle_box_content">
                  <div className="my-auto">
                    <h6>
                      Total Branch <br /> Offices
                    </h6>
                    <h5>{branchInfo.length}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProcessCovered;
